import React from "react";
import { IconButton, Snackbar, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store";
import { Box } from "@mui/system";
import Checkmark from "src/assets/Icons/CheckMark";
import CloseSnackbar from "src/assets/Icons/CloseSnackbar";
import Exclamation from "src/assets/Icons/Exclamation";
import AlertIcon from "src/assets/Icons/AlertIcon";
import { ClearSnackbar } from "src/slices/snackbar";

const CustomSnackbar = () => {
  const dispatch = useDispatch();
  const { snackbarMessage, snackbarOpen, snackbarStatus } = useSelector(
    (state: RootState) => state.Snackbar
  );

  return (
    <>
      {snackbarOpen && snackbarStatus === "success" && (
        <Snackbar
          id="snackbar-success"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={snackbarOpen}
          // autoHideDuration={5000}
          autoHideDuration={null}
          onClose={() => {
            dispatch(ClearSnackbar());
          }}
          className="success_snackbar"
        >
          <Box
            style={{
              backgroundColor: "#DDFFDE",
              color: "#11BD60",
              display: "flex",
              height: "50px",
              padding: "10px",
              alignItems: "center",
              borderRadius: "4px",
            }}
          >
            <Checkmark props={{ width: "20px", height: "20px" }} />
            <Box style={{ margin: "10px" }}>
              <Typography style={{ fontFamily: "poppins" }} id="alert-success">
                {" "}
                {snackbarMessage}
              </Typography>
            </Box>
            <IconButton
              onClick={() => {
                dispatch(ClearSnackbar());
              }}
            >
              <CloseSnackbar
                props={{ width: "15px", height: "15px", iconColor: "#11BD60" }}
              />
            </IconButton>
          </Box>
        </Snackbar>
      )}
      {snackbarOpen && snackbarStatus === "failure" && (
        <Snackbar
          id="snackbar-failure"
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={() => {
            dispatch(ClearSnackbar());
          }}
          className="failure_snackbar"
        >
          <Box
            style={{
              backgroundColor: "#FFE5E5",
              color: "#FF5A5A",
              display: "flex",
              height: "50px",
              padding: "10px",
              alignItems: "center",
              borderRadius: "4px",
            }}
          >
            <Exclamation
              props={{ width: "20px", height: "20px", iconColor: "#FF5A5A" }}
            />
            <Box style={{ margin: "10px" }}>
              <Typography style={{ fontFamily: "poppins" }} id="alert-failure">
                {" "}
                {snackbarMessage}
              </Typography>
            </Box>
            <IconButton
              onClick={() => {
                dispatch(ClearSnackbar());
              }}
            >
              <CloseSnackbar
                props={{ width: "15px", height: "15px", iconColor: "#FF5A5A" }}
              />
            </IconButton>
          </Box>
        </Snackbar>
      )}
      {snackbarOpen && snackbarStatus === "alert" && (
        <Snackbar
          id="snackbar-alert"
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={() => {
            dispatch(ClearSnackbar());
          }}
          className="alert_snackbar"
        >
          <Box
            style={{
              backgroundColor: "#FFF7CC",
              color: "#FF9900",
              display: "flex",
              height: "50px",
              padding: "10px",
              alignItems: "center",
              borderRadius: "4px",
            }}
          >
            <AlertIcon
              props={{ width: "20px", height: "20px", iconColor: "#FF5A5A" }}
            />
            <Box style={{ margin: "10px" }}>
              <Typography style={{ fontFamily: "poppins" }} id="error-alert">
                {" "}
                {snackbarMessage}
              </Typography>
            </Box>
            <IconButton
              onClick={() => {
                dispatch(ClearSnackbar());
              }}
            >
              <CloseSnackbar
                props={{ width: "15px", height: "15px", iconColor: "#FF5A5A" }}
              />
            </IconButton>
          </Box>
        </Snackbar>
      )}
    </>
  );
};

export default CustomSnackbar;
